import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CustomObjectsLegacyRedirect = lazy(() =>
  import("@scenes/CustomObjects").then((module) => ({
    default: module.CustomObjectsLegacyRedirect,
  }))
);

export const AccountsNRO: NavigationRoutingObject = {
  Component: CustomObjectsLegacyRedirect,
  componentFeatureFlippers: ["accounts_nro_component"],
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("accounts-nro-heading", "Accounts"),
  pageNameForTracking: () => "Accounts",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("accounts-nro-description", "Store business records and connect them to your users"),
  icon: "nav-system-accounts",
  tag: "early-access",
  // B2B access, not the React-migration flipper, decides whether Accounts is offered at all:
  // `b2b_ea` forwards to the custom objects list, `b2b_mvp` renders the legacy accounts table.
  // Workspaces with neither have no Accounts backend, so the entry point stays hidden.
  // The per-developer `viewCustomObjects` check belongs to the scenes, which render a
  // permission-required page rather than a 404.
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("accounts_nro_component") && (featureOn("b2b_ea") || featureOn("b2b_mvp"));
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/accounts/:appGroupId",
};
